(() => {
  const sections = document.querySelectorAll('[data-product-upsell]');
  if (!sections.length) return;
  sections.forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const moneyFormat = section.dataset.moneyFormat || '${{amount}}';
    const productId = String(section.dataset.productId || '');
    const shopDomain = section.dataset.shopDomain || 'gtglass.myshopify.com';
    const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
    const addToCartLabel = section.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';
    const track = section.querySelector('[data-upsell-track]');
    const bundlePrice = section.querySelector('[data-upsell-bundle-price]');
    const bundleCompare = section.querySelector('[data-upsell-bundle-compare]');
    const bundleButton = section.querySelector('[data-upsell-bundle-button]');
let activeFetchId = 0;
  
          const fallbackImage = (() => {
            const svg = [
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="none">',
              '<rect width="640" height="640" rx="48" fill="#EFE8DB"/>',
              '<path d="M178 420l86-92 78 74 74-55 102 109H178Z" fill="#D7CCBB"/>',
              '<circle cx="250" cy="228" r="34" fill="#D7CCBB"/>',
              '</svg>'
            ].join('');
  
            return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
          })();
  
          function fetchProducts() {
            const apiUrl = 'https://cdn.codeblackbelt.com/public/api/v1/frequently-bought-together?productId=' + encodeURIComponent(productId) + '&shop=' + encodeURIComponent(shopDomain);
  
            return fetch(apiUrl, {
              credentials: 'omit',
              headers: {
                Accept: 'application/json'
              }
            }).then((response) => {
              if (!response.ok) {
                throw new Error('Request failed: ' + response.status);
              }
  
              return response.json();
            }).then((payload) => {
              return normalizeProducts(payload);
            });
          }
  
          async function normalizeProducts(payload) {
            const rawProducts = Array.isArray(payload)
              ? payload
              : Array.isArray(payload && payload.recommendations)
                ? payload.recommendations
                : Array.isArray(payload && payload.products)
                  ? payload.products
                  : Array.isArray(payload && payload.items)
                    ? payload.items
                    : Array.isArray(payload && payload.data)
                      ? payload.data
                      : [];
  
            const hydratedProducts = await Promise.all(rawProducts
              .map(normalizeProduct)
              .filter(Boolean)
              .map(async (product) => {
                const detailedProduct = product.handle ? await fetchProductByHandle(product.handle) : null;
                return mergeProductDetails(product, detailedProduct);
              }));
  
            return hydratedProducts.filter((product) => {
              if (!product || String(product.id || '') === productId) return false;
              if (Array.isArray(product.variants) && product.variants.length > 0) {
                return product.variants.some((variant) => variant && variant.id && variant.available);
              }
              return true;
            });
          }
  
          function normalizeProduct(item) {
            if (!item) return null;
  
            const source = item.product || item.product_data || item.productData || item;
            const rawVariants = Array.isArray(source.variants) ? source.variants : [];
            const variants = rawVariants.map((v) => ({
              id: pickValue([v.id, v.variant_id, v.variantId]) || null,
              title: pickValue([v.title, v.name, (v.option1 && String(v.option1)), '']) || '',
              sku: pickValue([v.sku, v.sku_code, '']) || '',
              price: normalizeMoney(pickValue([v.price, v.price_cents, v.priceCents])),
              compareAtPrice: normalizeMoney(pickValue([v.compare_at_price, v.compareAtPrice, v.compare_price])),
              available: v.available === undefined || v.available === null ? true : Boolean(v.available),
              featuredImage: normalizeImage(pickValue([v.featured_image, v.featuredImage, v.image, v.image_url, v.imageUrl]))
            }));
  
            const firstAvailableVariant = source.selected_or_first_available_variant || variants.find((variant) => variant && variant.available) || variants[0] || null;
            const firstVariantWithCompareAt = variants.find((variant) => variant && variant.compareAtPrice !== null && variant.compareAtPrice !== undefined) || null;
            const variantId = pickValue([
              source.variant_id,
              source.variantId,
              source.selected_variant_id,
              firstAvailableVariant && firstAvailableVariant.id
            ]);
  
            const handle = pickValue([source.handle, source.product_handle, source.productHandle, item.handle]);
            const url = pickValue([
              source.url,
              source.product_url,
              source.productUrl,
              handle ? '/products/' + handle : null
            ]);
  
            const image = normalizeImage(pickValue([
              source.image,
              source.featured_image,
              source.featuredImage,
              source.image_url,
              source.imageUrl,
              source.thumbnail,
              source.thumbnailUrl,
              source.featured_media && source.featured_media.preview_image,
              source.featuredMedia && source.featuredMedia.previewImage
            ]));
  
            const priceSource = pickValue([
              source.price,
              source.price_cents,
              source.priceCents,
              source.current_price,
              firstAvailableVariant && (firstAvailableVariant.price || firstAvailableVariant.price_cents || firstAvailableVariant.priceCents)
            ]);
  
            const compareAtPriceSource = pickValue([
              source.compare_at_price,
              source.compareAtPrice,
              source.compare_price,
              source.comparePrice,
              firstAvailableVariant && (firstAvailableVariant.compare_at_price || firstAvailableVariant.compareAtPrice || firstAvailableVariant.compare_price)
            ]);
  
            const availableSource = pickValue([
              source.available,
              source.available_for_sale,
              source.in_stock,
              firstAvailableVariant && firstAvailableVariant.available
            ]);
  
            return {
              id: pickValue([source.product_id, source.productId, source.id]),
              title: String(pickValue([source.title, source.product_title, source.productTitle, source.name, 'Product']) || 'Product'),
              handle: handle,
              url: url,
              image: image,
              price: normalizeMoney(priceSource),
              compareAtPrice: normalizeMoney(compareAtPriceSource !== null && compareAtPriceSource !== undefined ? compareAtPriceSource : (firstVariantWithCompareAt && firstVariantWithCompareAt.compareAtPrice)),
              variantId: variantId,
              variantTitle: firstAvailableVariant && firstAvailableVariant.title || '',
              sku: pickValue([source.sku, firstAvailableVariant && firstAvailableVariant.sku]),
              variants: variants,
              available: availableSource === null || availableSource === undefined ? true : Boolean(availableSource)
            };
          }
  
          function mergeProductDetails(baseProduct, detailedProduct) {
            if (!detailedProduct) {
              return baseProduct;
            }
  
            return {
              id: detailedProduct.id || baseProduct.id,
              title: detailedProduct.title || baseProduct.title,
              handle: detailedProduct.handle || baseProduct.handle,
              url: detailedProduct.url || baseProduct.url,
              image: detailedProduct.image || baseProduct.image,
              price: detailedProduct.price !== null && detailedProduct.price !== undefined ? detailedProduct.price : baseProduct.price,
              compareAtPrice: detailedProduct.compareAtPrice !== null && detailedProduct.compareAtPrice !== undefined ? detailedProduct.compareAtPrice : baseProduct.compareAtPrice,
              variantId: detailedProduct.variantId || baseProduct.variantId,
              variantTitle: detailedProduct.variantTitle || baseProduct.variantTitle || '',
              sku: detailedProduct.sku || baseProduct.sku,
              variants: detailedProduct.variants && detailedProduct.variants.length ? detailedProduct.variants : (baseProduct.variants || []),
              available: detailedProduct.available !== null && detailedProduct.available !== undefined ? detailedProduct.available : baseProduct.available
            };
          }
  
          async function fetchProductByHandle(handle) {
            if (!handle) return null;
  
            try {
              const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
              });
  
              if (!response.ok) return null;
  
              const product = await response.json();
              return normalizeShopifyProductJson(product);
            } catch (error) {
              return null;
            }
          }
  
          function normalizeShopifyProductJson(product) {
            if (!product) return null;
  
            const variants = Array.isArray(product.variants) ? product.variants.map((v) => ({
              id: v.id,
              title: v.title || (v.option1 ? String(v.option1) : ''),
              sku: v.sku || '',
              price: normalizeMoney(v.price),
              compareAtPrice: normalizeMoney(v.compare_at_price),
              available: v.available === undefined || v.available === null ? true : Boolean(v.available),
              featuredImage: normalizeImage(v.featured_image)
            })) : [];
  
            const firstAvailableVariant = variants.find((variant) => variant && variant.available) || variants[0] || null;
            const firstVariantWithCompareAt = variants.find((variant) => variant && variant.compareAtPrice !== null && variant.compareAtPrice !== undefined) || null;
            const productImage = Array.isArray(product.images) && product.images.length ? product.images[0] : product.featured_image || '';
  
            return {
              id: product.id,
              title: product.title,
              handle: product.handle,
              url: product.url || '/products/' + product.handle,
              image: normalizeImage(productImage),
              price: normalizeMoney(firstAvailableVariant && firstAvailableVariant.price),
              compareAtPrice: normalizeMoney(firstAvailableVariant && firstAvailableVariant.compareAtPrice !== null && firstAvailableVariant.compareAtPrice !== undefined ? firstAvailableVariant.compareAtPrice : (firstVariantWithCompareAt && firstVariantWithCompareAt.compareAtPrice)),
              variantId: firstAvailableVariant && firstAvailableVariant.id,
              variantTitle: firstAvailableVariant && firstAvailableVariant.title || '',
              sku: firstAvailableVariant && firstAvailableVariant.sku,
              available: firstAvailableVariant ? Boolean(firstAvailableVariant.available) : true,
              variants: variants
            };
          }
  
          function normalizeImage(value) {
            if (!value) return '';
  
            if (typeof value === 'string') {
              return value;
            }
  
            if (typeof value === 'object') {
              return value.src || value.url || value.image || value.preview_image || value.previewImage || value.originalSrc || value.original_src || '';
            }
  
            return '';
          }
  
          function normalizeMoney(value) {
            if (value === null || value === undefined || value === '') {
              return null;
            }
  
            if (typeof value === 'number' && Number.isFinite(value)) {
              return Math.round(value);
            }
  
            const raw = String(value).trim().replace(/[^0-9.,-]/g, '');
            if (!raw) return null;
  
            if (raw.indexOf('.') > -1) {
              return Math.round(parseFloat(raw) * 100);
            }
  
            if (raw.indexOf(',') > -1 && raw.indexOf('.') === -1) {
              const commaParts = raw.split(',');
              if (commaParts.length === 2 && commaParts[1].length <= 2) {
                return Math.round(parseFloat(raw.replace(',', '.')) * 100);
              }
            }
  
            return Math.round(parseInt(raw, 10));
          }
  
          function pickValue(values) {
            for (let index = 0; index < values.length; index += 1) {
              const value = values[index];
              if (value !== null && value !== undefined && value !== '') {
                return value;
              }
            }
  
            return null;
          }
  
          function formatMoney(cents) {
            if (cents === null || cents === undefined || Number.isNaN(Number(cents))) {
              return '';
            }
  
            const normalizedCents = Math.round(Number(cents));
  
            if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
              try {
                return window.Shopify.formatMoney(normalizedCents, moneyFormat);
              } catch (error) {
                return fallbackMoney(normalizedCents);
              }
            }
  
            return fallbackMoney(normalizedCents);
          }
  
          function fallbackMoney(cents) {
            const value = (cents / 100).toFixed(2);
            return moneyFormat
              .replace(/\{\{\s*(amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/g, value.replace('.', ','))
              .replace(/\{\{\s*(amount_with_space_separator)\s*\}\}/g, value.replace('.', ' '))
              .replace(/\{\{\s*(amount_no_decimals)\s*\}\}/g, String(Math.round(cents / 100)))
              .replace(/\{\{\s*(amount_no_decimals_with_comma_separator)\s*\}\}/g, String(Math.round(cents / 100)).replace('.', ','))
              .replace(/\{\{\s*(amount)\s*\}\}/g, value)
              .replace(/\{\{\s*(amount_with_comma_separator)\s*\}\}/g, value.replace('.', ','))
              .replace(/\{\{\s*(amount_with_space_separator)\s*\}\}/g, value.replace('.', ' '));
          }
  
          function escapeHtml(value) {
            return String(value)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/\"/g, '&quot;')
              .replace(/'/g, '&#39;');
          }

          function getAvailableVariants(product) {
            if (!product || !Array.isArray(product.variants)) return [];
            return product.variants.filter((variant) => variant && variant.id && variant.available);
          }

          function renderVariantSelect(variants, product, cardId) {
            const productTitleLabel = escapeHtml(product.title || 'Product');
            const selectId = cardId + '-variant';
            const selectedId = String(product.variantId || '');
            const optionsMarkup = variants.map((variant) => {
              const id = String(variant.id || '');
              const isSelected = id && id === selectedId;
              const priceAttr = variant.price !== null && variant.price !== undefined ? String(variant.price) : '';
              const compareAttr = variant.compareAtPrice !== null && variant.compareAtPrice !== undefined ? String(variant.compareAtPrice) : '';
              return '<option value="' + escapeHtml(id) + '"'
                + ' data-price="' + escapeHtml(priceAttr) + '"'
                + ' data-compare-price="' + escapeHtml(compareAttr) + '"'
                + ' data-image="' + escapeHtml(variant.featuredImage || '') + '"'
                + (isSelected ? ' selected' : '')
                + '>' + escapeHtml(variant.title || '') + '</option>';
            }).join('');
            return '<div class="product-upsell__variant-slot">'
              + '<select class="product-upsell__variant-select" id="' + escapeHtml(selectId) + '" data-upsell-variant-select aria-label="Choose variant for ' + productTitleLabel + '">'
              + optionsMarkup
              + '</select></div>';
          }

          function renderVariantSlot(product, anyProductNeedsSlot, cardId) {
            if (!anyProductNeedsSlot) return '';
            const availableVariants = getAvailableVariants(product);
            if (availableVariants.length >= 2) {
              return renderVariantSelect(availableVariants, product, cardId);
            }
            const variantTitleRaw = product.variantTitle || '';
            if (variantTitleRaw && variantTitleRaw !== 'Default Title') {
              return '<div class="product-upsell__variant-slot"><span class="product-upsell__variant-text">' + escapeHtml(variantTitleRaw) + '</span></div>';
            }
            return '<div class="product-upsell__variant-slot" aria-hidden="true"></div>';
          }

          function handleVariantChange(select) {
            const row = select.closest('.product-upsell__row');
            const card = row && row.querySelector('[data-upsell-card]');
            if (!card) return;

            const option = select.options[select.selectedIndex];
            if (!option) return;

            const variantId = option.value || '';
            const priceAttr = option.getAttribute('data-price') || '';
            const compareAttr = option.getAttribute('data-compare-price') || '';
            const imageAttr = option.getAttribute('data-image') || '';

            card.setAttribute('data-variant-id', variantId);
            card.setAttribute('data-price', priceAttr);
            card.setAttribute('data-compare-price', compareAttr);

            const priceCents = priceAttr === '' ? null : Number(priceAttr);
            const compareCents = compareAttr === '' ? null : Number(compareAttr);
            const hasSale = priceCents !== null && compareCents !== null && compareCents > priceCents;

            const priceEl = card.querySelector('.product-upsell__price');
            if (priceEl) {
              priceEl.textContent = priceCents !== null ? formatMoney(priceCents) : '';
              priceEl.classList.toggle('is-sale', hasSale);
            }

            const compareEl = card.querySelector('.product-upsell__compare');
            if (compareEl) {
              compareEl.textContent = hasSale ? formatMoney(compareCents) : '';
              if (hasSale) {
                compareEl.removeAttribute('aria-hidden');
              } else {
                compareEl.setAttribute('aria-hidden', 'true');
              }
            }

            const imgEl = card.querySelector('[data-upsell-image]');
            if (imgEl) {
              const productImage = card.getAttribute('data-product-image') || '';
              const fallback = imgEl.getAttribute('data-upsell-fallback') || fallbackImage;
              const newSrc = imageAttr || productImage || fallback;
              if (newSrc && imgEl.src !== newSrc) {
                imgEl.src = newSrc;
              }
            }

            updateBundleSummary();
          }

          function renderProducts(products) {
            if (!Array.isArray(products) || !products.length) {
              hideSection();
              return;
            }
  
            const plusIcon = '<svg class="product-upsell__plus-divider" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 3.75V16.25M16.25 10L3.75 10" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

            const anyHasVariantTitle = products.some((p) => {
              const t = p && p.variantTitle;
              return t && t !== 'Default Title';
            });

            const anyProductHasSelector = products.some((p) => getAvailableVariants(p).length >= 2);
            const anyProductNeedsSlot = anyProductHasSelector || anyHasVariantTitle;

            const markup = products.map((product, index, array) => {
              const imageSrc = product.image || fallbackImage;
              const productUrl = product.url || (product.handle ? '/products/' + product.handle : '');
              const hasProductLink = Boolean(productUrl);
              const title = escapeHtml(product.title || 'Product');
              const price = product.price !== null && product.price !== undefined ? formatMoney(product.price) : '';
              const compareAt = product.compareAtPrice !== null && product.compareAtPrice !== undefined ? formatMoney(product.compareAtPrice) : '';
              const hasSalePrice = product.compareAtPrice && product.price !== null && product.compareAtPrice > product.price;
              const imageAlt = title;
              const variantTitleRaw = product.variantTitle || '';
              const showVariantTitle = variantTitleRaw && variantTitleRaw !== 'Default Title';
              const variantTitle = showVariantTitle ? escapeHtml(variantTitleRaw) : '';
              const variantId = product.variantId || '';
              const cardId = 'upsell-card-' + String(product.id || product.handle || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '-');
              const compareCents = product.compareAtPrice || '';
              const priceCents = product.price || '';
              const linkOpen = (modifier) => hasProductLink
                ? '<a class="product-upsell__card-link product-upsell__card-link--' + modifier + '" href="' + escapeHtml(productUrl) + '" tabindex="-1">'
                : '<div class="product-upsell__card-link product-upsell__card-link--' + modifier + '">';
              const linkClose = hasProductLink ? '</a>' : '</div>';

              const rowMarkup = [
                '<div class="product-upsell__row">',
                  '<div class="product-upsell__checkbox-wrap">',
                    '<input type="checkbox" class="product-upsell__checkbox-input" id="' + escapeHtml(cardId) + '" data-upsell-checkbox checked' + (variantId ? '' : ' disabled') + '>',
                    '<label class="product-upsell__checkbox-label" for="' + escapeHtml(cardId) + '" data-upsell-checkbox-label aria-label="Include ' + title + ' in bundle, currently selected"></label>',
                  '</div>',
                  '<article class="product-upsell__card" data-upsell-card data-card-id="' + escapeHtml(cardId) + '" data-product-title="' + title + '" data-variant-id="' + escapeHtml(String(variantId)) + '" data-price="' + escapeHtml(String(priceCents)) + '" data-compare-price="' + escapeHtml(String(compareCents)) + '" data-available="' + (product.available ? '1' : '0') + '" data-product-image="' + escapeHtml(product.image || '') + '">',
                    linkOpen('media'),
                      '<div class="product-upsell__media">',
                        '<img',
                          ' src="' + escapeHtml(imageSrc) + '"',
                          ' alt="' + imageAlt + '"',
                          ' loading="lazy"',
                          ' decoding="async"',
                          ' width="640"',
                          ' height="640"',
                          ' data-upsell-image',
                          ' data-upsell-fallback="' + escapeHtml(fallbackImage) + '"',
                        '>',
                      '</div>',
                    linkClose,
                    '<div class="product-upsell__body">',
                      linkOpen('title'),
                        '<h3 class="product-upsell__title">' + title + '</h3>',
                      linkClose,
                      renderVariantSlot(product, anyProductNeedsSlot, cardId),
                      '<div class="product-upsell__price-row">',
                        '<span class="product-upsell__price' + (hasSalePrice ? ' is-sale' : '') + '">' + escapeHtml(price) + '</span>',
                        '<span class="product-upsell__compare"' + (hasSalePrice ? '' : ' aria-hidden="true"') + '>' + (hasSalePrice ? escapeHtml(compareAt) : '') + '</span>',
                      '</div>',
                    '</div>',
                  '</article>',
                '</div>'
              ].join('');

              return index < array.length - 1 ? rowMarkup + plusIcon : rowMarkup;
            }).join('');
  
            track.innerHTML = markup;
            section.classList.remove('is-loading');
            section.classList.add('is-ready');
  
            bindImageFallbacks();
            bindSelectionHandlers();
            updateBundleSummary();
          }
  
          function bindImageFallbacks() {
            const images = track.querySelectorAll('[data-upsell-image]');
  
            images.forEach((image) => {
              image.addEventListener('error', () => {
                const fallback = image.getAttribute('data-upsell-fallback') || fallbackImage;
                if (image.src !== fallback) {
                  image.src = fallback;
                }
              }, { once: true });
            });
          }
  
          function bindSelectionHandlers() {
            const checkboxes = track.querySelectorAll('[data-upsell-checkbox]');

            checkboxes.forEach((checkbox) => {
              checkbox.addEventListener('change', () => {
                updateCheckboxAriaLabel(checkbox);
                updateBundleSummary();
              });
            });

            const variantSelects = track.querySelectorAll('[data-upsell-variant-select]');
            variantSelects.forEach((select) => {
              select.addEventListener('change', () => handleVariantChange(select));
            });

            if (bundleButton) {
              bundleButton.addEventListener('click', addSelectedProductsToCart);
            }
          }

          function updateCheckboxAriaLabel(checkbox) {
            const label = checkbox.parentElement && checkbox.parentElement.querySelector('[data-upsell-checkbox-label]');
            if (!label) return;
            const card = checkbox.closest('.product-upsell__row') && checkbox.closest('.product-upsell__row').querySelector('[data-upsell-card]');
            const title = card && card.getAttribute('data-product-title') || 'product';
            const stateText = checkbox.checked ? 'currently selected' : 'currently not selected';
            label.setAttribute('aria-label', 'Include ' + title + ' in bundle, ' + stateText);
          }
  
          function getSelectedCards() {
            return Array.from(track.querySelectorAll('.product-upsell__row')).map((row) => {
              const checkbox = row.querySelector('[data-upsell-checkbox]');
              const card = row.querySelector('[data-upsell-card]');
              if (!checkbox || !card || checkbox.disabled || !checkbox.checked) return null;
              return card;
            }).filter(Boolean);
          }
  
          function updateBundleSummary() {
            const selectedCards = getSelectedCards();
            const totalCents = selectedCards.reduce((sum, card) => sum + Number(card.getAttribute('data-price') || 0), 0);
            const compareCents = selectedCards.reduce((sum, card) => {
              const price = Number(card.getAttribute('data-price') || 0);
              const compare = Number(card.getAttribute('data-compare-price') || 0);
              return sum + (compare > price ? compare : price);
            }, 0);
  
            if (bundlePrice) {
              bundlePrice.textContent = formatMoney(totalCents);
            }
  
            if (bundleCompare) {
              bundleCompare.textContent = compareCents > totalCents ? formatMoney(compareCents) : '';
            }
  
            if (bundleButton) {
              bundleButton.disabled = !selectedCards.length;
            }
          }
  
          let isSubmittingCart = false;

          async function addSelectedProductsToCart() {
            if (isSubmittingCart) return;

            const selectedCards = getSelectedCards();
            const items = selectedCards.map((card) => ({
              id: Number(card.getAttribute('data-variant-id') || 0),
              quantity: 1
            })).filter((item) => item.id);

            if (!items.length) return;

            isSubmittingCart = true;

            if (bundleButton) {
              bundleButton.disabled = true;
              bundleButton.setAttribute('aria-busy', 'true');
            }

            try {
              const response = await fetch(cartAddUrl + '.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({ items: items })
              });

              if (!response.ok) {
                throw new Error('Cart add failed');
              }

              if (window.CustomCartDrawer) {
                window.CustomCartDrawer.refresh({ open: true });
              }
            } catch (error) {
              if (window.CustomCartDrawer) {
                window.CustomCartDrawer.refresh({ open: true });
              }
            } finally {
              isSubmittingCart = false;
              if (bundleButton) {
                bundleButton.removeAttribute('aria-busy');
              }
              updateBundleSummary();
            }
          }
  
          function hideSection() {
            section.classList.remove('is-loading', 'is-ready');
            section.classList.add('is-hidden');
            section.hidden = true;
          }
  
          function init() {
            fetchProducts()
              .then((products) => {
                if (activeFetchId !== 1) return;
                if (!products.length) {
                  hideSection();
                  return;
                }
  
                renderProducts(products);
              })
              .catch(() => {
                hideSection();
              });
          }
  
          activeFetchId = 1;
  
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init, { once: true });
          } else {
            init();
          }
        
  });
})();
